import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Outlet} from 'react-router-dom';
import {
  subscribeToGroup,
  unsubscribeFromGroup,
} from '../../redux/middleware/signalrMiddleware';
import {RootState} from '../../redux/store';
import {RoleNames} from '../../shared/constants';

const Review: React.FC = () => {
  const loginUserData = useSelector(
    (state: RootState) => state.authenticatedUser.user
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (loginUserData?.roleName === RoleNames.ReviewManager) {
      const groupSecurityGroup = `${loginUserData?.entityId}_${loginUserData?.projectId}_${loginUserData?.securityGroupId}`;
      dispatch(subscribeToGroup(groupSecurityGroup));
      return () => {
        dispatch(unsubscribeFromGroup(groupSecurityGroup));
      };
    }
  }, [loginUserData]);
  return <Outlet />;
};

export default Review;
